import { TicketsService } from "@/services";
import Alerts from "@/components/TicketsPage/CreateTicket/Alerts";
import Attachment from "@/components/TicketsPage/CreateTicket/Attachment";

export default {
  name: "create-ticket",
  components: { Alerts, Attachment },
  props: [],
  data() {
    return {
      title: "",
      description: "",
      categories: [],
      hints: [],
      categoryStep: 1,
      categoryId: 1,
      isTitleFocus: false,
      isDescriptionFocus: false,
      hoverCatId: 0,
      isTitleHover: false,
      isDescriptionHover: false,
      titleError: false,
      descriptionError: false,
      file: null,
      isRequesting: false
    };
  },
  computed: {
    titleNameStyle() {
      if (this.isTitleFocus) {
        return "transform:translateY(-10px);color:var(--v-primary-base);font-size:12px !important;";
      } else {
        if (this.title) {
          return "transform:translateY(-10px);font-size:12px !important;";
        } else {
          return `transform:translateY(0);font-size:10px;${this.isTitleHover &&
            "color:#56606B;"}`;
        }
      }
    },
    descriptionNameStyle() {
      if (this.isDescriptionFocus) {
        return "transform:translateY(-10px);color:var(--v-primary-base);font-size:12px !important;";
      } else {
        if (this.description) {
          return "transform:translateY(-10px);font-size:12px !important;";
        } else {
          return `transform:translateY(0);font-size:10px;${this
            .isDescriptionHover && "color:#56606B;"}`;
        }
      }
    },

    catrgoryStyle() {
      switch (this.categoryStep) {
        case 1:
          return "min-height: 600px;";

        case 2:
          return "min-height: 800px;";
      }
    },

    category() {
      return this.categories.find(cat => cat.id === this.categoryId);
    },

    isFormValid() {
      return this.title && this.description;
    }
  },
  mounted() {
    TicketsService.getCategories().then(
      res => (this.categories = res.data.data)
    );

    TicketsService.getHints().then(res => (this.hints = res.data.data));
  },
  methods: {
    categoryStepNext() {
      this.categoryStep++;
    },

    categoryStepBack() {
      this.categoryStep--;
    },

    setCategory(categoryId) {
      this.resetCategoryHover();
      this.categoryId = categoryId;
      this.categoryStepNext();
    },

    setTitle({ target: { value } }) {
      this.title = value;
    },

    setDescription({ target: { value } }) {
      this.description = value;
    },

    toggleTitleFocus() {
      this.isTitleFocus = !this.isTitleFocus;
    },

    toggleDescriptionFocus() {
      this.isDescriptionFocus = !this.isDescriptionFocus;
    },

    setFile(file) {
      this.file = file;
    },

    submit() {
      if (!this.title) {
        this.titleError = true;
      }

      if (!this.description) {
        this.descriptionError = true;
      }

      const data = {
        categoryId: this.categoryId,
        title: this.title,
        body: this.description,
        file: this.file
      };
      if (this.isFormValid) {
        TicketsService.create(data)
          .then(res => {
            this.$toast.success(res.data.message);
            this.$router.push(`/tickets/${res.data.data.id}`);
          })
          .finally(() => (this.isRequesting = false));
        this.isRequesting = true;
      }
    },

    setTitleHover(bool) {
      this.isTitleHover = bool;
    },

    setDescriptionHover(bool) {
      this.isDescriptionHover = bool;
    },

    setCategoryHover(categoryId) {
      this.hoverCatId = categoryId;
    },

    resetCategoryHover() {
      this.hoverCatId = 0;
    }
  },
  watch: {
    title(newTitle) {
      if (newTitle) {
        if (this.titleError) {
          this.titleError = false;
        }
      }
    },

    description(newDescription) {
      if (newDescription) {
        if (this.descriptionError) {
          this.descriptionError = false;
        }
      }
    }
  }
};
